import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/default_avatar.png'


const _withScopeId = n => (_pushScopeId("data-v-1da030f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-container" }
const _hoisted_2 = { class: "container-title-box" }
const _hoisted_3 = { class: "container-title-left-box" }
const _hoisted_4 = { class: "top-navbar" }
const _hoisted_5 = { class: "right-menu-box" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "el-dropdown-link username-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "avatar"
}, null, -1))
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_el_dropdown, {
              placement: "bottom",
              onCommand: _ctx.handleCommand
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { command: "backhome" }, {
                      default: _withCtx(() => [
                        _createTextVNode("返回首页")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                      default: _withCtx(() => [
                        _createTextVNode("退出登录")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.userInfo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.userInfo.name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["onCommand"])
          ])
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}